import mutations from './mutations.js';
import actions from './actions.js';
import getters from './getters.js';
export default {
  state() {
    return {
      clientID: null,
      walletID: null,
      firstName: null,
      lastName: null,
      balance: null,
      email: null,
      isOverseas: null,
      phone: null,
      clientCode: null,
      clientList: [],
      workshopSearchModel: null,
      currentPanel: null,
    };
  },
  mutations,
  actions,
  getters,
};
